var filtrar = false;
var filtros = null;
//Constrói o dropdown do filtro rapido
window.filtroRapido = (table, variaveis) =>{
    var dropdownHtml = '<div class="dropdown mx-2 icons-colaborador d-flex justify-content-center align-items-center" id="dpd-filtro-rapido" style="user-select: none;">' +
        '<span class="material-symbols-outlined icon-hover" id="dropdownMenuButton" data-toggle="dropdown" aria-expanded="false">filter_alt</span>' +
        '<div class="dropdown-menu dropdown-menu-right bg-surface" id="dropdown-filtro-rapido" aria-labelledby="dropdownMenuButton" style="cursor:auto; width:260px"><form>';

    // Obtenha todas as colunas
    var columns = table.settings().init().columns;
    // Itere sobre cada coluna
    for (var i = 0; i < columns.length; i++) {
        // Verifique se a coluna tem o atributo data- que você está procurando
        if ($('.table-header').eq(i).data('select')) {
            var dados = columns[i].data + 'Filtro';
            // Adicione o nome da coluna ao menu suspenso
            dropdownHtml += '<div class="uni-title-small text-grey-2 ml-4 mr-3 mt-3 mb-2 d-flex justify-content-between">' +
                $('.table-header').eq(i).text() +
                '<img src="' + `${window.location.origin}/assets/public/img/add_circle.svg` + '" class="opcoesFiltroRapido abrir-collapse-filtro" style="cursor:pointer" data-column="' + dados + '">' +
                '</div>';

            var coluna = dados;
            dados = variaveis[dados];
            // Itere sobre os dados da coluna
            for (let chave in dados) {
                if (dados.hasOwnProperty(chave)) {
                    dropdownHtml += '<div class="ml-3 mb-2 pl-1 align-items-center opcaoFiltroRapido d-none" data-column="' + coluna + '">' +
                                        '<input type="checkbox" class="mr-2 filtro-rapido-checkbox control-input-checkbox" data-dado="' + dados[chave] + '">' +
                                        '<span class="uni-body-medium text-grey-1 ml-1">' + dados[chave] + '</span>' +
                                    '</div>';
                }
            }

            dropdownHtml += '<hr class="ml-3 mr-3 mt-3 mb-1">'
        }
    }

    dropdownHtml += '<div class="ml-3 mr-3 mt-3 mb-1"><div id="filtrar-rapido" class="uni-btn uni-btn-filled w-100">Filtrar</div></div>'

    dropdownHtml += '</form></div></div>';

    return dropdownHtml;
}

window.abrirOpcoes = (item) =>{
    var icon = $(".opcoesFiltroRapido[data-column='" + item + "']");
    icon.attr("src", `${window.location.origin}/assets/public/img/do_not_disturb_on.svg`);
    icon.removeClass('abrir-collapse-filtro');
}

window.fecharOpcoes = (item) =>{
    var icon = $(".opcoesFiltroRapido[data-column='" + item + "']");
    icon.attr("src", `${window.location.origin}/assets/public/img/add_circle.svg`);
    var checkbox = $(".opcaoFiltroRapido[data-column='" + item + "']").find('.filtro-rapido-checkbox');
    checkbox.prop('checked', false);
    icon.addClass('abrir-collapse-filtro');
}

//Abrir e fechar opções de filtro (inputs)
jQuery(document).on('click', '.opcoesFiltroRapido', function () {
    var itensFiltro = $(".opcaoFiltroRapido[data-column='" + $(this).data('column') + "']");
    if(itensFiltro.hasClass('d-none')){
        abrirOpcoes($(this).data('column'));
        itensFiltro.removeClass('d-none').addClass('d-flex');
    } else {
        fecharOpcoes($(this).data('column'));
        itensFiltro.removeClass('d-flex').addClass('d-none');
    }
})

//pegar inputs selecionados
window.getFiltrosSelecionados = () =>{
    const filtros = {};

    // Percorre cada checkbox com a classe filtro-rapido-checkbox
    $('.filtro-rapido-checkbox').each(function() {
        const checkbox = $(this);
        if (checkbox.is(':checked')) {
            const nomeColuna = checkbox.closest('.opcaoFiltroRapido').data('column');
            const valorFiltro = checkbox.attr('data-dado');
            if (!filtros.hasOwnProperty(nomeColuna)) {
                filtros[nomeColuna] = [];
            }
            filtros[nomeColuna].push(valorFiltro);
        }
    });
    return filtros;
}

//função para recarregar datatable e tags
window.filtrarRapido = () => {
    table.ajax.reload(null, false);
    table.page(0).draw(false);
    carregarTags();
}

jQuery(document).on('click', '#filtrar-rapido', function () {
    filtrar = true;
    filtrarRapido();
    $(".icons-colaborador .dropdown-menu").collapse("hide");
})

window.carregarTags = () => {
    $('.filtrosTags').remove();
    $('.containerTags').remove();
    const containerTags = '<span class="d-flex justify-content-start align-items-center containerTags"></span>';
    $(containerTags).insertBefore('#tabela-colaboradores');

    const filtrosSelecionados = getFiltrosSelecionados(); // Obter os dados do array de filtros
    for (const nomeColuna in filtrosSelecionados) {
        const numeroFiltros = filtrosSelecionados[nomeColuna].length;
        let nomeTag = nomeColuna.replace(/Filtro/g, "");
        nomeTag = nomeTag.charAt(0).toUpperCase() + nomeTag.slice(1);
        if(nomeTag === 'Vinculo') nomeTag = 'Vínculo';
        var tagFiltro = '<span class="tagStyle d-flex align-items-center"><span class="d-flex align-items-center dropdown tag-dropdown">' +
                                    '<span class="filtrosTags d-flex align-items-center" data-column="' + nomeColuna + '" id="dropdown' + nomeColuna + '" data-toggle="dropdown" aria-expanded="false">' +
                                        '<span class="' + nomeColuna + 'Tag uni-label-large" style="margin-right:0.20rem">'+ nomeTag +'</span><span class="' + nomeColuna + 'NmrFiltro uni-label-large">(' + numeroFiltros + ')</span>' +
                                    '</span>' +
                                    '<div class="dropdown-menu dropdown-menu-center p-2 align-self-center bg-surface" aria-labelledby="dropdown' + nomeColuna + '"><form style="margin:0 !important"><div class="dropdownTags"  data-column="' + nomeColuna + '"></div></form></div>' +
                                  '</span>' +
                                  '<span class="material-symbols-outlined fechar-tag ml-1" data-column="'+ nomeColuna+'">close</span> </span>';
        $(tagFiltro).appendTo($('.containerTags'));
    }
    if(typeof tagFiltro !== 'undefined'){
        const fecharTudo =   '<span class="d-flex align-items-center limparTudoTags">' +
                                        '<span class="uni-btn uni-btn-text d-flex align-items-center limpar-filtro-rapido-tags"> Limpar todos </span>' +
                                    '</span>';
        $(fecharTudo).appendTo($('.containerTags'));
    }
}

jQuery(document).on('click', '.fechar-tag', function () {
    filtrar = true;
    var divOpcoes = $(".opcaoFiltroRapido[data-column='" + $(this).data('column') + "']");
    divOpcoes.find('input[type="checkbox"]').prop('checked', false);
    filtrarRapido();
    abrirFecharCollpases();
})

jQuery(document).on('click', '.limpar-filtro-rapido-tags', function () {
    filtrar = true;
    $('.filtro-rapido-checkbox').prop('checked', false);
    $('.limparTudoTags').remove();
    filtrarRapido();
    abrirFecharCollpases();
})

//dropdown das tags
jQuery(document).on('click', '.filtrosTags', function () {
    $(".opcaoFiltroRapido[data-column='" + $(this).data('column') + "']").each(function(index, element) {
        var checkbox = $(element).children('.filtro-rapido-checkbox');
        var tagCheckboxValue = checkbox.data('dado');
        var checked = checkbox.prop('checked');

        dropdownTag =   '<div class="d-flex align-items-center opcaoFiltroRapidoTag" data-column="' + $(this).data('column') + '">' +
                            '<input' + (checked ? ' checked ' : ' ') +  'type="checkbox" class="mr-2 filtro-rapido-checkbox-tag control-input-checkbox" data-dado="' + tagCheckboxValue + '">' +
                            '<span class="uni-body-medium text-grey-1 ml-1">' + tagCheckboxValue + '</span>' +
                        '</div>';
        $('.dropdownTags[data-column="' + $(this).data('column') + '"]').append(dropdownTag);
    })
})

//filtrar pelas tags
$(document).on('change', '.filtro-rapido-checkbox-tag', function (){
    var dado = $(this).data('dado');
    var checked = $(this).prop('checked');
    var checkbox = $('.filtro-rapido-checkbox[data-dado="' + dado + '"]');
    checkbox.prop('checked', checked);
    table.ajax.reload(null, false);
    table.page(0).draw(false);

    const filtrosSelecionados = getFiltrosSelecionados();
    for (const nomeColuna in filtrosSelecionados) {
        const numeroFiltros = filtrosSelecionados[nomeColuna].length;
        $('.'+nomeColuna+'NmrFiltro').text('('+numeroFiltros+')');
    }

    var dataColumns = [];
    //opcaoFiltroRapido com o mesmo data-column
    $(".opcaoFiltroRapidoTag").each(function() {
        const dataColumn = $(this).data('column');
        if (!dataColumns.includes(dataColumn)) { // Check if data-column attribute exists
            dataColumns.push(dataColumn);
        }
    });
    $(dataColumns).each(function (index,element) {
        var inputsFiltro = $(".opcaoFiltroRapidoTag[data-column='" + element + "']").find('input[type="checkbox"]:checked');
        if(inputsFiltro.length === 0){
            carregarTags();
        }
    })
})

//fecha o collapse se não tem checkbox selecionado
window.fecharCollapse = (column) => {
    fecharOpcoes(column);
    $(".opcaoFiltroRapido[data-column='" + column + "']").removeClass('d-flex').addClass('d-none');
}
//abrir o collapse se tem checkbox selecionado
window.abrirCollapse = (column) =>{
    abrirOpcoes(column);
    $(".opcaoFiltroRapido[data-column='" + column + "']").removeClass('d-none').addClass('d-flex');
}

window.abrirFecharCollpases = ()=>{
    var dataColumns = [];
    //opcaoFiltroRapido com o mesmo data-column
    $(".opcaoFiltroRapido").each(function() {
        const dataColumn = $(this).data('column');
        if (!dataColumns.includes(dataColumn)) { // Check if data-column attribute exists
            dataColumns.push(dataColumn);
        }
    });

    $(dataColumns).each(function (index,element){
        var divOpcoes = $(".opcaoFiltroRapido[data-column='" + element + "']");
        var inputsFiltro = divOpcoes.find('input[type="checkbox"]');
        var algumCheckboxSelecionado = false;

        // Verificar se algum checkbox está selecionado
        inputsFiltro.each(function() {
            if ($(this).prop('checked')) {
                algumCheckboxSelecionado = true;
                return false;
            }
        });
        if (!algumCheckboxSelecionado) {
            fecharCollapse(element);
        } else {
            abrirCollapse(element);
        }
    })
}

//função para desmarcar checkbox ao fechar dropdown e nao clicar em filtrar
$(document).on('show.bs.dropdown', '#dpd-filtro-rapido', event => {
    filtros = getFiltrosSelecionados(); // pega filtros antes de selecionar novos
})
$(document).on('hide.bs.dropdown', '#dpd-filtro-rapido', function() {
    if(!filtrar){// se nao clicou em filtrar
        //desmarca todos inputs
        $('.filtro-rapido-checkbox').prop('checked', false)
        //marca inputs que estavam no filtro quando foi aberto
        $.each(filtros, function(index, object) {
            $.each(object, function(index, object) {
                $('.filtro-rapido-checkbox[data-dado='+ object +']').prop('checked', true);
            })
        })
    }
    filtrar = false;
    abrirFecharCollpases();
})
